import * as React from 'react';
import {SketchPicker} from 'react-color';

import {IconAvatar} from '../avatar/icon-avatar';
import {colors} from '../colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {PlusThinIcon} from '../icon/svg/plus-thin-icon';
import {Popover} from '../popover/popover';

import styles from './color-picker.module.css';

type Props = {
    currentColor: string;
    onSetCurrentColor: (arg1: string) => void;
    showTransparent?: boolean;
    openButton?: 'swatch' | 'plus';
};

export function ColorPicker(props: Props) {
    const [isColorPickerOpen, setIsColorPickerOpen] = React.useState<boolean>(false);
    const container = React.useRef();

    /*
    This component accepts 2 possible color definitions (and their string length):

    #rrggbbaa (9)
    #rrggbb (7)
    #rgb (4)

    We want to match the text by RegEx to make sure the supplied color is in the
    correct format
    */
    const match = props.currentColor.match(/^#([a-fA-F0-9]{8}|[a-fA-F0-9]{6}|[a-fA-F0-9]{3})$/gi);

    if (match === null) {
        throw new Error('Unrecognized color value was supplied!');
    }

    return (
        <>
            {props.openButton === 'plus' ? (
                // @ts-expect-error
                <button onClick={() => setIsColorPickerOpen(true)} ref={container}>
                    <IconAvatar
                        backgroundColor={colors.white}
                        iconColor={colors.greyLt}
                        iconSize={16}
                        avatarSize={32}
                        icon={PlusThinIcon}
                        hasBorder={true}
                    />
                </button>
            ) : (
                <div
                    // @ts-expect-error
                    ref={container}
                    onClick={() => setIsColorPickerOpen(true)}
                    className={styles.container}
                >
                    <div
                        style={{backgroundColor: props.currentColor}}
                        className={styles['preview-swatch']}
                    />
                    {props.currentColor.toLowerCase() === '#ffffff00'
                        ? 'No background'
                        : props.currentColor}
                </div>
            )}
            {isColorPickerOpen && (
                <Popover
                    anchor={container.current}
                    location='bottom'
                    noDefaultStyling={true}
                    offsetPosition={4}
                    onBlur={() => setIsColorPickerOpen(false)}
                >
                    <SketchPicker
                        disableAlpha={true}
                        color={props.currentColor}
                        onChangeComplete={(newColor) => {
                            props.onSetCurrentColor(
                                // Format this color as:
                                // #HEX{00 FOR TRANSPARENT COLORS}
                                `${newColor.hex}${newColor.rgb.a === 0 ? '00' : ''}`
                            );
                        }}
                    />
                    {props.showTransparent ? (
                        <button
                            onClick={() => {
                                props.onSetCurrentColor('#FFFFFF00');
                            }}
                            className={styles['transparent-button']}
                        >
                            No background
                        </button>
                    ) : undefined}
                </Popover>
            )}
        </>
    );
}
